import { render, staticRenderFns } from "./DocDetail.vue?vue&type=template&id=688b3d31&"
import script from "./DocDetail.vue?vue&type=script&lang=ts&"
export * from "./DocDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports